import { Box, ThemeProvider, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import Theme from "../utils/theme";
import type { IPost } from "../types/post";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import PostCard from "../components/PostCard";
import { useParams } from "react-router-dom";
import Loading from "../components/Loading";

const SinglePost: React.FC = () => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    const { postId: RouteId } = useParams();

    const [post, setPost] = useState<IPost | null>(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setError(false);
        setLoading(true);

        axios
            .get(`${process.env.REACT_APP_API_URL}/posts/fetchById`, { params: { postId: RouteId } })
            .then((res) => {
                setPost(res.data.body);
            })
            .catch((err) => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [RouteId]);

    const renderContent = useMemo(() => {
        if (loading) return <Loading />;
        else if (error) return <Typography>404 Post not found</Typography>;
        else if (post !== null) return <PostCard post={post as IPost} />;
        else return <Typography>404 Post not found</Typography>;
    }, [error, loading, post]);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: "flex", width: "100vw", alignItems: "center", justifyContent: "center", pt: 5 }}>
                <Box sx={{ width: "100%", maxWidth: 1200 }}>{renderContent}</Box>
            </Box>
        </ThemeProvider>
    );
};

export default SinglePost;
